<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <span>
                <v-btn plain icon v-bind="attrs" v-on="on" v-on:click="actionClick()">
                    <v-icon medium>mdi-backburger</v-icon>
                </v-btn>
            </span>
        </template>
        <span>back to...</span>
    </v-tooltip>      
</template>

<script>
    export default {
        methods: {
            actionClick(){
                this.$emit('actionClick', 'backtosubmenu');
            },
        }
    }
</script>